var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceCategoriesMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.089,
    height: 35.157,
    viewBox: "0 0 31.089 35.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-service-categories",
    transform: "translate(-398 -629.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks",
    d: "M11.7,20.9,7.8,24.917l-2.462-2.25,1.03-1.221L7.8,22.819l2.763-3.052L11.7,20.9Z",
    transform: "translate(396.468 627.708)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks-2",
    "data-name": "Path_format-list-checks",
    d: "M11.7,20.9,7.8,24.917l-2.462-2.25,1.03-1.221L7.8,22.819l2.763-3.052L11.7,20.9Z",
    transform: "translate(396.468 620.613)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks-3",
    "data-name": "Path_format-list-checks",
    d: "M11.7,20.9,7.8,24.917l-2.462-2.25,1.03-1.221L7.8,22.819l2.763-3.052L11.7,20.9Z",
    transform: "translate(396.468 634.803)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 7,
    height: 1.5,
    transform: "translate(410.5 650.054)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 7,
    height: 1.5,
    transform: "translate(410.5 657)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    transform: "translate(398 634.378)",
    fill: "none",
    stroke: "#0000b5",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 30,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 28.5,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    transform: "translate(404.613 629.22)",
    fill: "#0000b5",
    stroke: "#0000b5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.238,
    cy: 12.238,
    r: 12.238,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.238,
    cy: 12.238,
    r: 11.488,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(-308.087 410.702) rotate(-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_753919_tools_working_options_preferences_settings_icon",
    "data-name": "753919_tools_working_options_preferences_settings_icon",
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 579.832, 495.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M10.967,13.744a.756.756,0,0,0-.858-.149v0c-.045.015-.089.033-.135.048-.015.005-.024.011-.041.018a.966.966,0,0,0-.729.815v.644a.644.644,0,0,1-.674.659H8.266c-.562.011-.663-.332-.677-.516v-.742c0-.682-.761-.87-.761-.87l0,0a5.571,5.571,0,0,1-1.168-.5c-.015-.007-.027-.011-.044-.019a.963.963,0,0,0-1.075.127l-.524.524c-.366.364-.636.195-.736.1l-.042-.043,0,0h0l-.43-.43,0,0c-.337-.336.1-.8.16-.857l.511-.51s0,0,0,0a.933.933,0,0,0,.084-1.007h.005a5.562,5.562,0,0,1-.475-1.135c0-.01-.008-.017-.012-.028a1,1,0,0,0-.926-.7l-.5,0c-.581,0-.686-.377-.7-.575v-.4a.605.605,0,0,1,.651-.638h0l.636,0a.847.847,0,0,0,.812-.611c0-.008.007-.012.01-.02a5.5,5.5,0,0,1,.551-1.328h0a.971.971,0,0,0-.187-1.125L3,4.025H3a.582.582,0,0,1-.032-.882l.225-.225a.662.662,0,0,1,.979,0h0l.492.492a.872.872,0,0,0,1.014.132l0,0A5.549,5.549,0,0,1,6.8,3.066c.01,0,.016-.009.028-.014.63-.248.747-.636.765-.837V1.481A.581.581,0,0,1,8.2.875h.353a.631.631,0,0,1,.644.7v.554a.952.952,0,0,0,.666.9h0a5.434,5.434,0,0,1,1.051.416l0,0a1.115,1.115,0,0,0,1.33-.1l.383-.383c.018-.018.536-.519.923-.132l0,0,.317.316a.7.7,0,0,1-.1.953l-.429.429a1.03,1.03,0,0,0-.122,1.152c.006.012.006.019.011.031a5.54,5.54,0,0,1,.469,1.15l.005,0s.139.7.759.694l.6,0h.043c.017,0,.736-.012.737.667l0,.285h0v.07c-.006.168-.086.588-.754.59l-.578,0a.879.879,0,0,0-.775.61.693.693,0,0,0,.193.75l.082.081,0,0c.476.511.816-.2.816-.2a.871.871,0,0,1,.7-.443h.881a.485.485,0,0,0,.485-.485V7.231a.485.485,0,0,0-.485-.485h-.841a.859.859,0,0,1-.826-.612l-.006,0a6.666,6.666,0,0,0-.343-.823,0,0,0,0,0,0,0,.868.868,0,0,1,.217-.928l.536-.537a.486.486,0,0,0,0-.686L13.584,1.578a.486.486,0,0,0-.686,0l-.39.389a1.025,1.025,0,0,1-1.179.317v0A6.973,6.973,0,0,0,10.656,2l-.029-.014a1.007,1.007,0,0,1-.582-.941V.485A.485.485,0,0,0,9.559,0H7.231a.485.485,0,0,0-.485.485v.7a.77.77,0,0,1-.594.809l0,0a6.885,6.885,0,0,0-.751.314l-.011,0a.706.706,0,0,1-.82-.062l-.017-.017,0,0h0L3.9,1.577a.486.486,0,0,0-.686,0L1.629,3.157a.485.485,0,0,0,0,.686l.526.526a.889.889,0,0,1,.23.933h0a6.681,6.681,0,0,0-.338.8c-.007.014-.013.025-.02.042a.886.886,0,0,1-.776.6H.485A.485.485,0,0,0,0,7.231V9.468a.485.485,0,0,0,.485.485h.871a.651.651,0,0,1,.622.454l.006-.012a6.743,6.743,0,0,0,.359.912h0s.308.522-.037.866h0l-.677.677a.485.485,0,0,0,0,.686L3.208,15.12a.484.484,0,0,0,.686,0l.609-.608v0l.027-.027a.831.831,0,0,1,.942-.062l.015.006a6.9,6.9,0,0,0,.665.275l0,0a.846.846,0,0,1,.6.776v.734a.485.485,0,0,0,.485.485H9.56a.485.485,0,0,0,.485-.485v-.8a.751.751,0,0,1,.507-.676l.039-.018c.161-.056.316-.125.472-.191.376-.209.027-.635.027-.635Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_753919_tools_working_options_preferences_settings_icon-2",
    "data-name": "753919_tools_working_options_preferences_settings_icon",
    transform: "translate(575.483 479.464) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436-2",
    "data-name": "Path 1436",
    d: "M10.967,13.744a.756.756,0,0,0-.858-.149v0c-.045.015-.089.033-.135.048-.015.005-.024.011-.041.018a.966.966,0,0,0-.729.815v.644a.644.644,0,0,1-.674.659H8.266c-.562.011-.663-.332-.677-.516v-.742c0-.682-.761-.87-.761-.87l0,0a5.571,5.571,0,0,1-1.168-.5c-.015-.007-.027-.011-.044-.019a.963.963,0,0,0-1.075.127l-.524.524c-.366.364-.636.195-.736.1l-.042-.043,0,0h0l-.43-.43,0,0c-.337-.336.1-.8.16-.857l.511-.51s0,0,0,0a.933.933,0,0,0,.084-1.007h.005a5.562,5.562,0,0,1-.475-1.135c0-.01-.008-.017-.012-.028a1,1,0,0,0-.926-.7l-.5,0c-.581,0-.686-.377-.7-.575v-.4a.605.605,0,0,1,.651-.638h0l.636,0a.847.847,0,0,0,.812-.611c0-.008.007-.012.01-.02a5.5,5.5,0,0,1,.551-1.328h0a.971.971,0,0,0-.187-1.125L3,4.025H3a.582.582,0,0,1-.032-.882l.225-.225a.662.662,0,0,1,.979,0h0l.492.492a.872.872,0,0,0,1.014.132l0,0A5.549,5.549,0,0,1,6.8,3.066c.01,0,.016-.009.028-.014.63-.248.747-.636.765-.837V1.481A.581.581,0,0,1,8.2.875h.353a.631.631,0,0,1,.644.7v.554a.952.952,0,0,0,.666.9h0a5.434,5.434,0,0,1,1.051.416l0,0a1.115,1.115,0,0,0,1.33-.1l.383-.383c.018-.018.536-.519.923-.132l0,0,.317.316a.7.7,0,0,1-.1.953l-.429.429a1.03,1.03,0,0,0-.122,1.152c.006.012.006.019.011.031a5.54,5.54,0,0,1,.469,1.15l.005,0s.139.7.759.694l.6,0h.043c.017,0,.736-.012.737.667l0,.285h0v.07c-.006.168-.086.588-.754.59l-.578,0a.879.879,0,0,0-.775.61.693.693,0,0,0,.193.75l.082.081,0,0c.476.511.816-.2.816-.2a.871.871,0,0,1,.7-.443h.881a.485.485,0,0,0,.485-.485V7.231a.485.485,0,0,0-.485-.485h-.841a.859.859,0,0,1-.826-.612l-.006,0a6.666,6.666,0,0,0-.343-.823,0,0,0,0,0,0,0,.868.868,0,0,1,.217-.928l.536-.537a.486.486,0,0,0,0-.686L13.584,1.578a.486.486,0,0,0-.686,0l-.39.389a1.025,1.025,0,0,1-1.179.317v0A6.973,6.973,0,0,0,10.656,2l-.029-.014a1.007,1.007,0,0,1-.582-.941V.485A.485.485,0,0,0,9.559,0H7.231a.485.485,0,0,0-.485.485v.7a.77.77,0,0,1-.594.809l0,0a6.885,6.885,0,0,0-.751.314l-.011,0a.706.706,0,0,1-.82-.062l-.017-.017,0,0h0L3.9,1.577a.486.486,0,0,0-.686,0L1.629,3.157a.485.485,0,0,0,0,.686l.526.526a.889.889,0,0,1,.23.933h0a6.681,6.681,0,0,0-.338.8c-.007.014-.013.025-.02.042a.886.886,0,0,1-.776.6H.485A.485.485,0,0,0,0,7.231V9.468a.485.485,0,0,0,.485.485h.871a.651.651,0,0,1,.622.454l.006-.012a6.743,6.743,0,0,0,.359.912h0s.308.522-.037.866h0l-.677.677a.485.485,0,0,0,0,.686L3.208,15.12a.484.484,0,0,0,.686,0l.609-.608v0l.027-.027a.831.831,0,0,1,.942-.062l.015.006a6.9,6.9,0,0,0,.665.275l0,0a.846.846,0,0,1,.6.776v.734a.485.485,0,0,0,.485.485H9.56a.485.485,0,0,0,.485-.485v-.8a.751.751,0,0,1,.507-.676l.039-.018c.161-.056.316-.125.472-.191.376-.209.027-.635.027-.635Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 3.936,
    cy: 3.936,
    r: 3.936,
    transform: "translate(581.617 481.584)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCategoriesMaster);
export default __webpack_public_path__ + "static/media/service-categories-master.3184b3d44181de8bb49a90dc29ecddf5.svg";
export { ForwardRef as ReactComponent };